import { render, staticRenderFns } from "./menu-item.vue?vue&type=template&id=da669aee&"
import script from "./menu-item.vue?vue&type=script&lang=js&"
export * from "./menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da669aee')) {
      api.createRecord('da669aee', component.options)
    } else {
      api.reload('da669aee', component.options)
    }
    module.hot.accept("./menu-item.vue?vue&type=template&id=da669aee&", function () {
      api.rerender('da669aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/menu/src/menu-item.vue"
export default component.exports